import { UserInvite } from 'app/modules/user-management/user-invite/components/InviteUser/UserInvite';

export const UserInvitePage = (): JSX.Element => <UserInvite />;
